<template>
  <div>
    <b-modal
      id="modal-recruit-job-posting"
      ref="modal_recruit_job_posting"
      :title="title"
      size="xl"
      lazy
      centered
      scrollable
      no-close-on-backdrop
      no-close-on-esc
      hide-footer
      @hidden="onHidden"
    >
      <b-skeleton-wrapper :loading="isBusy">
        <template #loading>
          <b-form>
            <b-card bg-variant="light">
              <b-row class="mt-2 mb-2">
                <b-col cols="3">
                  <b-skeleton width="21%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="3">
                  <b-skeleton width="53%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="13%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="35%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="42%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-5">
                <b-col>
                  <b-skeleton width="10%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="109%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="5%" height="22%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-form>
        </template>

        <template #default>
          <b-form>
            <b-card bg-variant="light">
              <b-row class="align-items-end">
                <b-col cols="3">
                  <b-form-group id="group-provider-select" label="Сервис">
                    <b-form-select
                      type="text"
                      size="sm"
                      v-model="newItem.provider_id"
                      :options="providerOptions"
                      :disabled="isViewDisabled"
                    >
                      <template #first>
                        <b-form-select-option :value="0" disabled>Выберите сервис</b-form-select-option>
                      </template>
                    </b-form-select>
                  </b-form-group>
                </b-col>
                <b-col cols="3">
                  <b-form-group id="group-recruit-task-id-select" label="Заявка на подбор">
                    <recruit-task-select
                      size="sm"
                      ref="recruit_task_id_select"
                      :is-disabled="selectDisabled || isViewDisabled"
                      :value="newItem.recruit_task_id"
                      @onSelect="onRecruitTaskIdSelect"
                      @onClear="onClearSelected"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="group-vacancy" label="Вакансия">
                    <b-form-input
                        type="text"
                        size="sm"
                        :disabled="isDisabled"
                        v-model="newItem.location_vacancy_name"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group id="group-location" label="Объект">
                <b-form-input
                  type="text"
                  size="sm"
                  :disabled="isDisabled"
                  v-model="newItem.location_name"
                />
              </b-form-group>
              <b-row>
                <b-col>
                  <b-form-group id="group-opened-date" label="Дата открытия вакансии">
                    <b-form-input
                      size="sm"
                      type="date"
                      :disabled="isDisabled"
                      v-model.date="newItem.opened_date"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group id="group-opened-date" label="Дата первого выхода в смену">
                    <b-form-input
                        size="sm"
                        type="date"
                        :disabled="isViewDisabled"
                        v-model.date="newItem.closed_date"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-form-group id="group-vacancy-text" label="Текст вакансии">
                <b-form-textarea
                  type="text"
                  size="sm"
                  :rows="3"
                  resize
                  :disabled="isViewDisabled"
                  v-model="newItem.text"
                />
              </b-form-group>
              <b-form-group id="group-organization" label="Организация">
                <b-form-input
                  type="text"
                  size="sm"
                  :disabled="isDisabled"
                  v-model="newItem.organization_name"
                />
              </b-form-group>
              <b-form-group id="group-assigned" label="Работодатель">
                <b-form-select
                  type="text"
                  size="sm"
                  v-model="newItem.assigned"
                  :disabled="isViewDisabled"
                  :options="assignedOptions"
                />
              </b-form-group>
              <b-form-group id="group-status" label="Статус">
                <b-form-select
                  size="sm"
                  v-model="newItem.status"
                  :disabled="isViewDisabled"
                  :options="statusOptions"
                />
              </b-form-group>
            </b-card>
          </b-form>
        </template>
      </b-skeleton-wrapper>

      <template>
        <div class="w-100 d-flex justify-content-end py-2">
<!--    TODO Публикация      -->

<!--          <b-button size="sm" variant="info" :disabled="loading" @click="">-->
<!--            <b-spinner v-if="loading" small/>-->
<!--            <font-awesome-icon icon="search-plus" class="mr-1"/>-->
<!--            Опубликовать-->
<!--          </b-button>-->
          <b-button size="sm" variant="secondary" class="ml-auto mr-1" @click="handleCancel">
            Отменить
          </b-button>
          <b-button size="sm" variant="success" :disabled="loading || isViewDisabled" @click="handleOk">
            <b-spinner v-if="loading" small/>
            <font-awesome-icon icon="save" class="mr-1"/>
            Сохранить
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import recruitJobPostings from "../../network/recruitJobPostings";
import recruitTasks from "../../network/recruitTasks";
import catalogs from "../../network/catalogs";
import locations from "../../network/locations";
import locationVacancies from "../../network/locationVacancies";
import users from "../../network/users";
  import helpers from "../../utilites/helpers";
  import dateFormatter from "../../utilites/dateFormatter";
    import RecruitTaskSelect from "./RecruitTaskSelect.vue";

export default {
  name: 'RecruitJobPosting',
  components: { RecruitTaskSelect },
  mixins: [
    recruitJobPostings, recruitTasks, catalogs, locations, users, locationVacancies,
    helpers, dateFormatter
  ],
  data() {
    return {
      title:`Объявление`,
      newItem: this.setNewItem(),
      locationUsers: [],
      statusOptions: [
        { value: 'created', text: 'Создано'},
        { value: 'in_progress', text: 'В работе' },
        { value: 'published', text: 'Опубликовано' },
        { value: 'canceled', text: 'Отменено' },
        { value: 'done', text: 'Готово' },
      ],
      providerOptions: [
        { value: 1, text: 'Авито' },
        { value: 2, text: 'HH' }
      ],
      isDisabled: true,
      isViewDisabled: true,
      recruitTaskIdDisabled: false,
      isBusy: false,
      loading: false,
    }
  },
  computed: {
    assignedOptions() {
      if (!this.locationUsers || this.locationUsers.length === 0) return [];

      return this.locationUsers.map(u => ({
        value: u.id,
        text: u.name + ` (${u.role_name})`
      }));
    },
    selectDisabled() {
      return (this.newItem.id > 0) || this.recruitTaskIdDisabled;
    }
  },
  async mounted() {
    const recruitTaskId = this.$route.params.recruitTaskId;
    this.recruitTaskIdDisabled = this.$route.params.recruitTaskDisabled;

    this.isViewDisabled = this.$route.query.mode === 'view';

    if (recruitTaskId) {
      await this.fillJobPosting(recruitTaskId);
    }
  },
  methods: {
    setNewItem() {
      return {
        id: 0,
        recruit_task_id: 0,
        provider_id: 0,
        provider_name: '',
        provider_post_id: null,
        provider_post_uuid: null,
        provider_post_status: '',
        provider_published_date: null,
        assigned: 0,
        status: 'created',
        text: '',
        location_id: 0,
        location_name: '',
        location_vacancy_id: 0,
        location_vacancy_name: '',
        opened_date: null,
        closed_date: null,
        organization_id: 0,
        organization_name: '',
      };
    },
    async showModal(jobPostingId, isView) {
      this.isViewDisabled = isView;
      this.newItem = this.setNewItem();
      this.locationUsers = [];
      this.$refs.modal_recruit_job_posting.show();

      if (jobPostingId) {
        await this.getJobPosting(jobPostingId);
      }
    },
    hideModal() {
      this.$refs.modal_recruit_job_posting.hide();
    },
    handleOk() {
      this.handleSubmit();
      this.hideModal();
    },
    handleCancel() {
      this.hideModal();
    },
    onHidden() {
      this.newItem = this.setNewItem();
      this.recruitTaskIdDisabled = false;
      this.isViewDisabled = true;
      this.$emit('modal-closed');
    },
    async getJobPosting(jobPostingId) {
      this.isBusy = true;
      this.loading = true;

      const result = await this.getJobPostingById(jobPostingId);

      if (!result || !result.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = result.data;

      this.newItem.opened_date = this.formattedFromServerDate(this.newItem.opened_date);
      this.newItem.closed_date = this.formattedFromServerDate(this.newItem.closed_date);
      this.newItem.provider_published_date = this.formattedFromServerDate(this.newItem.provider_published_date);

      await this.getLocationUsersAndOrganization(this.newItem.location_id);

      this.isBusy = false;
      this.loading = false;
    },

    async fillJobPosting(recruitTaskId) {
      this.isBusy = true;
      const result = await this.getRecruitTaskById(recruitTaskId);

      if (result.data) {
        const task = result.data;

        this.newItem.recruit_task_id = task.id;
        this.newItem.location_id = task.location_id;
        this.newItem.location_name = task.location_name;
        this.newItem.location_vacancy_id = task.location_vacancy_id;
        this.newItem.location_vacancy_name = task.location_vacancy_name;
        this.newItem.opened_date = this.formattedFromServerDate(task.opened_date);
        this.newItem.closed_date = this.formattedFromServerDate(task.closed_date);
        this.newItem.assigned = task.assigned;

        await this.getLocationUsersAndOrganization(task.location_id);
        await this.getVacancyText(task.location_id, task.location_vacancy_id);
      }

      this.$refs.modal_recruit_job_posting.show();
      this.isBusy = false;
    },
    async getLocationUsersAndOrganization(locationId) {
      if (!locationId) {
        this.locationUsers = [];
        return;
      }

      const location = await this.getLocationById(locationId);

      if (location && location.data) {
        this.newItem.organization_id = location.data.organization_id;
        this.newItem.organization_name = location.data.organization_name;

        const uniqueUserIds = [...new Set(location.data.location_users.map(item => item.user_id))];
        const promises = uniqueUserIds.map(id => this.getUserById(id));
        const result = await Promise.all(promises);

        this.locationUsers = result.map(res => res.data)
      } else {
        this.locationUsers = [];
      }
    },
    async getVacancyText(locationId, locationVacancyId) {
      const result = await this.getLocationVacancyByLocationId(locationId);

      const vacancyData = result.data.items.find(v => v.id === locationVacancyId);
      this.newItem.text = this.generateVacancyTextString(vacancyData);
    },
    async handleSubmit() {
      this.loading = true;
      const data = this.newItem;
      data.opened_date = this.formattedToServerDate(data.opened_date);
      data.closed_date = this.formattedToServerDate(data.closed_date);
      const provider = this.providerOptions.find(option => option.value === data.provider_id);

      if (provider) this.newItem.provider_name = provider.text;

      const method = (data.id > 0) ? this.putJobPosting : this.postJobPosting;
      const result = await method(data);

      if (!result.data) {
        this.showError("Не удалось сохранить данные.");
        this.loading = false;
        return;
      }

      this.newItem.id = result.data.id;
      this.loading = false;
      this.$emit('refresh');
    },
    async onRecruitTaskIdSelect(recruitTaskId) {
      this.newItem.recruit_task_id = recruitTaskId;

      if (recruitTaskId) {
        await this.fillJobPosting(recruitTaskId);
      }
    },
    onClearSelected() {
      this.newItem = this.setNewItem();
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Recruiting/RecruitJobPosting.vue